import React from "react"
import {checkBrowser} from "./Util"
import {Alert} from "antd"

const InternetExplorerAlert = () => checkBrowser()
    ? <Alert type="info" showIcon message="We noticed you are using Internet Explorer"
             description="We recommend to use Firefox, Edge, or Chrome for an optimal experience."/>
    : null;

export default InternetExplorerAlert



// WEBPACK FOOTER //
// ./src/js/util/InternetExplorerAlert.js